import { ChangeDetectorRef, Component } from '@angular/core';
import {
  TGFormControlQuestionDirective
} from '../form-control-question';
import { SurveyService } from '../../../../core/services/survey/survey.service';
import { Validators } from '@angular/forms';

@Component({
  selector: 'tgf-form-checkbox-question',
  templateUrl: './form-checkbox-question.component.html',
  styleUrls: ['./form-checkbox-question.component.scss']
})
export class FormCheckboxQuestionComponent extends TGFormControlQuestionDirective {
  constructor(surveyService: SurveyService,
              changeDetectorRef: ChangeDetectorRef) {
    super(surveyService, changeDetectorRef);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  isSelected(value: string): boolean {
    return this.control?.value && this.control?.value.includes(value);
  }

  onCheckboxChange(value: string, target: any): void {
    if (target?.checked) {
      this.addValue(value);
    } else {
      this.removeValue(value);
    }
  }

  private addValue(value: string): void {
    if (!this.isSelected(value)) {
      if (this.control?.value) {
        this.control?.value.push(value);
      } else {
        this.control?.setValue([value]);
      }
    }
    this.control?.updateValueAndValidity();
    this.changeDetectorRef.detectChanges();
  }

  private removeValue(value: string): void {
    const index = this.control?.value.findIndex((checkboxValue: any) => checkboxValue === value);
    if (index >= 0) {
      this.control?.value.splice(index, 1);
    }
    this.control?.updateValueAndValidity();
    this.changeDetectorRef.detectChanges();
  }

  override controlHasError(): boolean | null | undefined {
    return super.controlHasError() ||
      (this.control?.hasValidator(Validators.required) && this.control?.value?.length === 0 && this.control.touched);
  }

  override getErrorMessage(): any {
    return super.getErrorMessage() || 'Response required';
  }
}
